export const ru = {
    'default-tab-name': 'Стандартные',
    'idea-tab-name': 'Изображения со страницы',
    'recently-used-tab-name': 'Ранее использованные'
};
